export default __webpack_public_path__ + "static/media/P50001.d126dee4.png";